/* ============================================================
   Gaming Bundle Variant Cards — native theme port.
   Cards are rendered server-side by snippets/gaming-variant-cards.liquid.
   This script wires each card to the theme's hidden native picker
   (variant-radios / variant-selects) so Dawn updates the price,
   gallery, URL and the form's variant id, and keeps the cards in
   sync when the variant changes from anywhere else (sticky bar, etc.).
   ============================================================ */
(function () {
  // Unique flag — must NOT collide with the legacy Visually widget, which
  // uses window.__hexVariantCards and would otherwise make one script bail.
  if (window.__hexNativeVariantCards) return;
  window.__hexNativeVariantCards = true;

  var SCOPE = ".product__info-wrapper";

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function root() {
    return q("[data-hexvs]");
  }

  // The theme's native picker element (radios preferred, dropdown fallback).
  function pickerEl() {
    return (
      q(SCOPE + " variant-radios") ||
      q("variant-radios") ||
      q(SCOPE + " variant-selects") ||
      q("variant-selects")
    );
  }

  function currentValue() {
    var host = pickerEl();
    if (!host) return null;
    var checked = q('input[type="radio"]:checked', host);
    if (checked) return checked.value;
    var sel = q("select", host);
    return sel ? sel.value : null;
  }

  // Drive the native picker so Dawn reacts (price / media / url / form id).
  function selectValue(value) {
    var host = pickerEl();
    if (!host) return;

    var radios = qa('input[type="radio"]', host);
    if (radios.length) {
      var target = radios.filter(function (r) {
        return r.value === value;
      })[0];
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event("input", { bubbles: true }));
        target.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      var sel = q("select", host);
      if (sel && sel.value !== value) {
        sel.value = value;
        sel.dispatchEvent(new Event("input", { bubbles: true }));
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    sync();
  }

  function sync() {
    var cur = currentValue();
    var el = root();
    var nameEl = el && q("[data-hexvs-name]", el);
    qa(".hexvs__card").forEach(function (card) {
      var on = card.getAttribute("data-value") === cur;
      card.setAttribute("aria-checked", on ? "true" : "false");
      if (on && nameEl) {
        nameEl.textContent = card.getAttribute("data-name") || cur || "";
      }
      if (on) setSoldOutText(card.classList.contains("hexvs__card--soldout"));
    });
  }

  function setSoldOutText(sold) {
    var label = sold
      ? (window.variantStrings && window.variantStrings.soldOut) || "Sold out"
      : "";
    qa('product-form [name="add"]').forEach(function (button) {
      var text = button.querySelector("span");
      if (!text) return;
      if (sold) {
        if (!button.dataset.hexvsLabel) button.dataset.hexvsLabel = text.textContent;
        text.textContent = label;
        button.setAttribute("disabled", "disabled");
      } else if (button.dataset.hexvsLabel) {
        text.textContent = button.dataset.hexvsLabel;
        button.removeAttribute("disabled");
        delete button.dataset.hexvsLabel;
      }
    });
  }

  var changeBound = false;
  function bind() {
    var el = root();
    if (!el) return false;

    qa(".hexvs__card", el).forEach(function (card) {
      if (card.__hexBound) return;
      card.__hexBound = true;
      card.addEventListener("click", function () {
        selectValue(card.getAttribute("data-value"));
      });
    });

    if (!changeBound) {
      changeBound = true;
      // Keep cards in sync when the variant is changed by any other control.
      document.addEventListener(
        "change",
        function (e) {
          var t = e.target;
          if (!t) return;
          if (
            (t.matches && (t.matches('input[type="radio"]') || t.matches("select"))) ||
            (t.tagName === "SELECT")
          ) {
            sync();
          }
        },
        true
      );
    }

    sync();
    return true;
  }

  function init() {
    if (bind()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (bind() || ++tries >= 30) clearInterval(timer);
    }, 300);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
